<template>
	<div>
		<vue-headful
			title="¿Dudas con tu orden?"
			description="Completa nuestro formulario para recibir información y consultar cualquier duda sobre los estudios de laboratorio solicitados."
		/>
		<div class="front front--page">
			<div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--dudas"></div>
			<div class="container">
				<h1 class="title title--big color--white">¿Dudas con tu Orden?</h1>
				<div class="separator separator--white"></div>
			</div>
		</div>

		<div class="page-body">
			<div class="container">
				<h2 class="color--light-blue">Para recibir información y consultar cualquier duda sobre los estudios de laboratorio solicitados, por favor complete el siguiente formulario, con los datos del paciente:</h2>

				<form @submit.prevent="doubtsRequest" role="form" class="form" enctype="multipart/form-data">
					<div class="form__block">
						<legend>Datos personales</legend>

						<div class="row">
							<div class="col-sm-6">
								<div class="form-group">
									<input v-model="doubtsForm.form.first_name" type="text" class="form-control" id="" placeholder="Nombre">
									<div v-if="doubtsForm.errors.first_name" class="text-danger form-group">
										{{ doubtsForm.errors.first_name[0] }}
									</div>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
									<input v-model="doubtsForm.form.last_name" type="text" class="form-control" id="" placeholder="Apellido">
									<div v-if="doubtsForm.errors.last_name" class="text-danger form-group">
										{{ doubtsForm.errors.last_name[0] }}
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-6">
								<div class="form-group">
									<!-- <input type="text" class="form-control" id="" placeholder="Fecha de Nacimiento XX/XX/XX"> -->
									<datepicker v-model="doubtsForm.form.born_date" :placeholder="'Fecha de Nacimiento'" :input-class="'form-control'" :language="'es'"></datepicker>
									<div v-if="doubtsForm.errors.born_date" class="text-danger form-group">
										{{ doubtsForm.errors.born_date[0] }}
									</div>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
									<input v-model="doubtsForm.form.phone" type="text" class="form-control" id="" placeholder="Teléfono">
									<div v-if="doubtsForm.errors.phone" class="text-danger form-group">
										{{ doubtsForm.errors.phone[0] }}
									</div>
								</div>
							</div>
						</div>

						<div class="form-group">
							<input v-model="doubtsForm.form.email" type="text" class="form-control" id="" placeholder="Email">
							<div v-if="doubtsForm.errors.email" class="text-danger form-group">
								{{ doubtsForm.errors.email[0] }}
							</div>
						</div>

						<div class="row">
							<div class="col-sm-6">
								<div class="form-group">
									<select v-model="doubtsForm.form.coverage" class="form-control" style="color: rgba(85, 85, 85, 0.7)">
										<option v-if="doubtsForm.form.coverage == null" selected disabled :value="null">Cobertura Médica</option>
										<option>AATRA</option>
										<option>ACA SALUD</option>
										<option>ACMI</option>
										<option>AERI</option>
										<option>AJAMOP</option>
										<option>AMEBPBA</option>
										<option>AMEM</option>
										<option>AMFFA</option>
										<option>AMTYCA</option>
										<option>APOC</option>
										<option>APPI-OSPCYQ</option>
										<option>APPI-OSTV</option>
										<option>APRES</option>
										<option>APSOT</option>
										<option>ASM SALUD</option>
										<option>ASOCIACION JUDICIAL BONAERENSE</option>
										<option>ATE</option>
										<option>ATGGBA</option>
										<option>CAJA NOTARIAL</option>
										<option>CAJA DE ESCRIBANOS</option>
										<option>CASA</option>
										<option>COMEI</option>
										<option>CONFERENCIA EPISCOPAL ARGENTINA</option>
										<option>CONTADURIA</option>
										<option>CPM</option>
										<option>DASMI</option>
										<option>FATSA</option>
										<option>FEBOS</option>
										<option>GALENO</option>
										<option>HEALTH MEDICAL</option>
										<option>IOMA</option>
										<option>IOSFA</option>
										<option>ISALUD</option>
										<option>JERARQUICOS SALUD</option>
										<option>MANDAR SALUD SA.</option>
										<option>MUTUAL FEDERADA 25 DE JUNIO</option>
										<option>OBRA SOCIAL DE FUTBOLISTAS</option>
										<option>OBRAS SANITARIAS</option>
										<option>OPDEA</option>
										<option>OSAP</option>
										<option>OSAPM</option>
										<option>OSBLYCA</option>
										<option>OSDEL</option>
										<option>OSDEPYM</option>
										<option>OSDOP</option>
										<option>OSECAC</option>
										<option>OSEMM</option>
										<option>OSFATLYF</option>
										<option>OSFATUN</option>
										<option>OSFE</option>
										<option>OSFOT</option>
										<option>OSIAD</option>
										<option>OSJERA</option>
										<option>OSMECON</option>
										<option>OSPEDYC</option>
										<option>OSPEGAP</option>
										<option>OSPEPBA</option>
										<option>OSPERHYRA</option>
										<option>OSPESA</option>
										<option>OSPIA</option>
										<option>OSPICA</option>
										<option>OSPIL</option>
										<option>OSPILM</option>
										<option>OSPIM</option>
										<option>OSPLAD</option>
										<option>OSPOCE</option>
										<option>OSPPRA</option>
										<option>OSPRERA</option>
										<option>OSPSA</option>
										<option>OSPSIP</option>
										<option>OSPTV</option>
										<option>OSSEG</option>
										<option>OSSIMRA</option>
										<option>OSVARA</option>
										<option>PAMI</option>
										<option>PERSONAL LEGISLATIVO</option>
										<option>PODER JUDICIAL</option>
										<option>POLICIA</option>
										<option>PREVENCION SALUD</option>
										<option>SADAIC</option>
										<option>SANCOR SALUD</option>
										<option>SCA</option>
										<option>SCIS SA</option>
										<option>SEPUBA</option>
										<option>SERVESALUD</option>
										<option>SIMECO</option>
										<option>SOEME</option>
										<option>SPB</option>
										<option>SPS</option>
										<option>SSP</option>
										<option>STMLa</option>
										<option>SUTEBA</option>
										<option>SWISS MEDICAL</option>
										<option>UAI SALUD</option>
										<option>U.DOC.P.BSAS</option>
										<option>UNIMED</option>
										<option>UNLP</option>
										<option>UPCN (COSEGURO DE IOMA)</option>
										<option>VETERANOS DE GUERRA</option>
									</select>
									<div v-if="doubtsForm.errors.coverage" class="text-danger form-group">
										{{ doubtsForm.errors.coverage[0] }}
									</div>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
									<input v-model="doubtsForm.form.plan" type="text" class="form-control" id="" placeholder="Plan">
									<div v-if="doubtsForm.errors.plan" class="text-danger form-group">
										{{ doubtsForm.errors.plan[0] }}
									</div>
									<!-- <select v-model="doubtsForm.form.plan" class="form-control">
										<option v-if="doubtsForm.form.plan == null" selected disabled :value="null">Plan</option>
										<option>Todos</option>
									</select> -->
								</div>
							</div>
						</div>
					</div>

					<div class="form__block">
						<legend>Orden</legend>
						<div class="row">
							<div class="col-sm-6">
								<div class="row">
									<div class="col-xs-4">
										<label class="file-select">
											<div class="button text-center">
												<span v-if="doubtsForm.form.order_file1">Cambiar archivo</span>
												<span v-else>Adjuntar orden 1</span>
											</div>
											<p class="text-center" v-if="doubtsForm.form.order_file1">Archivo seleccionado: {{doubtsForm.form.order_file1.name}}</p>
											<input type="file" @change="onOrderFileChange($event, 1)">
										</label>
									</div>
									<div class="col-xs-4">
										<label class="file-select">
											<div class="button text-center">
												<span v-if="doubtsForm.form.order_file2">Cambiar archivo</span>
												<span v-else>Adjuntar orden 2</span>
											</div>
											<p class="text-center" v-if="doubtsForm.form.order_file2">Archivo seleccionado: {{doubtsForm.form.order_file2.name}}</p>
											<input type="file" @change="onOrderFileChange($event, 2)">
										</label>
									</div>
									<div class="col-xs-4">
										<label class="file-select">
											<div class="button text-center">
												<span v-if="doubtsForm.form.order_file3">Cambiar archivo</span>
												<span v-else>Adjuntar orden 3</span>
											</div>
											<p class="text-center" v-if="doubtsForm.form.order_file3">Archivo seleccionado: {{doubtsForm.form.order_file3.name}}</p>
											<input type="file" @change="onOrderFileChange($event, 3)">
										</label>
									</div>
								</div>
								<div v-for="error in doubtsForm.errors.order_file1" class="text-danger form-group">
									{{ error }}
								</div>
								<div v-for="error in doubtsForm.errors.order_file2" class="text-danger form-group">
									{{ error }}
								</div>
								<div v-for="error in doubtsForm.errors.order_file3" class="text-danger form-group">
									{{ error }}
								</div>
								<div class="form-group">
									<b class="color--boston-blue">
										Puede adjuntar hasta 3 órdenes de un mismo paciente.
									</b>
									<div>
										Formatos válidos: .JPG, .PNG, .GIF y .PDF. Peso máximo: 5MB.
									</div>
								</div>
							</div>
							<div class="col-sm-6">
								<textarea v-model="doubtsForm.form.comments" name="" id="input" class="form-control" rows="5" required="required" placeholder="Comentarios"></textarea>
								<div class="text-right">
									<i>Hasta 1000 caracteres disponibles</i>
								</div>
							</div>
						</div>
					</div>

					<div class="text-right">
						<!-- <vue-recaptcha class="g-recaptcha" sitekey="6LfApD8UAAAAAK1jNp7jTMWPigcTN8y8Q8K8H4Zd"></vue-recaptcha> -->
					</div>

					<div v-if="!doubtsForm.sended" class="text-right">
						<div v-if="!doubtsForm.sending">
							<button type="submit" class="button button--dark">Enviar</button>			
						</div>
						<div v-else>
							<div class="button button--dark">Enviando ...</div>
						</div>
					</div>
					<div v-else>
						<div class="text-center">
							<p><b>¡Su mensaje ha sido enviado!</b></p>
							<p>Pronto estaremos revisando su solicitud.</p>
						</div>
					</div>
				</form>
			</div>
		</div>

		<div v-if="showModal">
			<div id="dudasModal" class="modal fade" role="dialog" ref="dudasModal">
				<div class="modal-dialog">
					<div class="modal__wrapper">
						<div class="close-btn" data-dismiss="modal" @click.prevent="closeModal()">
							<div class="icon-bar"></div>
						</div>

						<p class="color--blue">
							Les recordamos a nuestros pacientes que para solicitar el precio de un estudio y su preparación deberán enviarnos la orden médica escaneada con las siguientes características.
						</p>
						<p class="color--blue">
							La imagen de la orden debe verse completa incluyendo los márgenes y legible. Se desestimarán las fotos que se vean borrosas o no cumplan con dichas condiciones.
						</p>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import Datepicker from 'vuejs-datepicker';

export default {
	name: 'dudas',
	components: {VueRecaptcha, Datepicker},
	data() {
		return {
			showModal: true,
			doubtsForm: {
				sended: false,
				sending: false,
				allow: true,
				errors: [],
				form: {
					first_name: null,
					last_name: null,
					born_date: null,
					phone: null,
					email: null,
					coverage: null,
					plan: null,
					comments: null,
					order_file1: null,
					order_file2: null,
					order_file3: null
				}
			}
		}
	},
	methods: {
		doubtsRequest: function() {
			this.doubtsForm.errors = [];
			this.doubtsForm.sending = true;

			var form_data = new FormData();

			for ( var field in this.doubtsForm.form ) {
				if (this.doubtsForm.form[field] != null) {
				form_data.append(field, this.doubtsForm.form[field]);
				}
			}

			this.$http.post('http://www.varelab.com.ar/api/public/api/form/doubts', form_data).then(response => {
				 console.log(response.body.success);
				 if (response.body.success) {
					 this.doubtsForm.sended = true;
				 }
				 if (response.body.error) {
					this.doubtsForm.errors = response.body.error;
				 } else if( response.body.messages ) {
					this.doubtsForm.errors = response.body.messages;
					console.log(this.doubtsForm.errors);
				 }

				 this.doubtsForm.sending = false;
			}, response => {
				if (response.body.error) {
					this.doubtsForm.errors = response.body.error;
				}
			});
		},
		onOrderFileChange: function( e, order) {
		  var files = e.target.files || e.dataTransfer.files;
		  if (!files.length)
			return;

			switch(order) {
				case 1:
					this.doubtsForm.form.order_file1 = files[0];
					break;
				case 2:
					this.doubtsForm.form.order_file2 = files[0];
					break;
				case 3:
					this.doubtsForm.form.order_file3 = files[0];
					break;
				default:
					return;
			}
		},
		removeCv: function ( e, order ) {
		  this.doubtsForm.form.cv_file = '';
		},
		closeModal: () => {
			this.showModal = !this.showModal;
		}
	},
	mounted() {
		if (this.showModal) {
	    	$(this.$refs.dudasModal).modal("show");			
		}
	}
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Servicios/Dudas.vue